mrp = {
  enableLogging: true,
  themeKey: "data-theme",
  darkTheme: "dark",
  lightTheme: "light",
  authenticationChangeKey: "authentication-change",
  // logging hook
  log(message) {
    if (!this.enableLogging) {
      return;
    }
    console.log(message);
  },
  // Initialize MRP
  init() {
    this.log("mrp init");
    this.loadTheme();
    // Initialize theme and auth change listeners after load
    window.onload = () => {
      this.log("mrp init - window load handler");
      this.checkAuthenticationChange();
      this.setThemeIndicator();
      this.hookThemeSwitcher();
      this.hookMenus();
    };
    // Listen for local storage changes
    window.addEventListener("storage", (evt) => {
      this.log("mrp init - storage handler");
      if (evt.key === this.authenticationChangeKey) {
        this.doAuthenticationChange(true);
      }
      if (evt.key === this.themeKey) {
        this.loadTheme();
        this.setThemeIndicator();
      }
    });
    // Set theme for OS preference change if auto theme is set
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", () => {
        this.log("mrp init - prefers-color-scheme change handler");
        this.loadTheme();
        this.setThemeIndicator();
      });
    // Set theme and menu handlers on full-page hx-swap
    document.addEventListener("htmx:afterSettle", (evt) => {
      this.log("mrp init - htmx:afterSettle handler");
      if (evt.target !== document.body) {
        //partial response, so no need to hook handlers
        return;
      }
      this.setThemeIndicator();
      this.hookThemeSwitcher();
      this.hookMenus();
    });
  },
  // Set the correct theme
  loadTheme() {
    this.log("mrp loadTheme");
    const preferredTheme = localStorage.getItem(this.themeKey);
    if (preferredTheme === null) {
      if (window.matchMedia(`(prefers-color-scheme: dark)`).matches) {
        document.documentElement.setAttribute(this.themeKey, this.darkTheme);
        return;
      }
      document.documentElement.setAttribute(this.themeKey, this.lightTheme);
      return;
    }
    if (preferredTheme === this.darkTheme) {
      document.documentElement.setAttribute(this.themeKey, this.darkTheme);
      return;
    }
    document.documentElement.setAttribute(this.themeKey, this.lightTheme);
  },
  // Set the theme switcher icon
  setThemeIndicator() {
    this.log("mrp setThemeIndicator");
    const autoThemeIndicator = document.getElementById("auto_theme_indicator");
    const lightThemeIndicator = document.getElementById(
      "light_theme_indicator"
    );
    const darkThemeIndicator = document.getElementById("dark_theme_indicator");
    let preferredTheme = localStorage.getItem(this.themeKey);
    if (preferredTheme === null) {
      lightThemeIndicator.classList.add("hidden");
      darkThemeIndicator.classList.add("hidden");
      autoThemeIndicator.classList.remove("hidden");
      return;
    }
    if (preferredTheme === this.darkTheme) {
      autoThemeIndicator.classList.add("hidden");
      lightThemeIndicator.classList.add("hidden");
      darkThemeIndicator.classList.remove("hidden");
      return;
    }
    //light
    autoThemeIndicator.classList.add("hidden");
    darkThemeIndicator.classList.add("hidden");
    lightThemeIndicator.classList.remove("hidden");
  },
  // Hook theme switcher handlers
  hookThemeSwitcher() {
    this.log("mrp hookThemeSwitcher");
    // Theme change process
    const handleThemeChange = () => {
      this.loadTheme();
      this.setThemeIndicator();
      this.closeMenus();
    };
    // Handle click for OS preference (auto)
    document
      .getElementById("auto_theme_button")
      .addEventListener("click", () => {
        localStorage.removeItem(this.themeKey);
        handleThemeChange();
      });
    // Handle click for light theme preference
    document
      .getElementById("light_theme_button")
      .addEventListener("click", () => {
        localStorage.setItem(this.themeKey, this.lightTheme);
        handleThemeChange();
      });
    // Handle click for dark theme preference
    document
      .getElementById("dark_theme_button")
      .addEventListener("click", () => {
        localStorage.setItem(this.themeKey, this.darkTheme);
        handleThemeChange();
      });
  },
  // Check for authentication change
  checkAuthenticationChange() {
    this.log("mrp checkAuthenticationChange");
    const hasChanged =
      window.location.pathname.toLowerCase() ===
      `/${this.authenticationChangeKey}`;
    if (hasChanged) {
      localStorage.setItem(
        this.authenticationChangeKey,
        `${this.authenticationChangeKey}-${Math.random()}`
      );
      this.doAuthenticationChange(false);
      return;
    }
    if (
      window.location.pathname.toLowerCase() !== "/login" &&
      window.location.pathname.toLowerCase() !== "/impersonate"
    ) {
      localStorage.setItem("current-pathname", window.location.pathname);
    }
  },
  // Change authentication state
  doAuthenticationChange(isOtherTabTriggered) {
    this.log("mrp doAuthenticationChange");
    if (
      window.location.pathname.toLowerCase() ===
      `/${this.authenticationChangeKey}`
    ) {
      const params = new URL(document.location.toString()).searchParams;
      const path = params.get("redirect-url");
      if (path === null) {
        this.resetCurrentLocation();
      } else {
        window.location.replace(path);
      }
      return true;
    }
    if (isOtherTabTriggered === true) {
      this.resetCurrentLocation();
      return;
    }
    window.location.replace("/");
  },
  // Reset attempted route on authentication change
  resetCurrentLocation() {
    this.log("mrp resetCurrentLocation");
    const current = localStorage.getItem("current-pathname");
    if (current) {
      window.location.replace(current);
      return;
    }
    window.location.replace("/");
  },
  // Details auto close
  hookMenus() {
    this.log("mrp hookMenus");
    const allDetails = document.querySelectorAll("details");
    function toggleOpenOneOnly() {
      if (this.open) {
        allDetails.forEach((det) => {
          if (det != this && det.open) det.open = false;
        });
      }
    }
    allDetails.forEach((det) => {
      det.addEventListener("toggle", toggleOpenOneOnly);
    });
  },
  // Close menus
  closeMenus() {
    this.log("mrp closeMenus");
    const allDetails = document.querySelectorAll("details");
    allDetails.forEach((det) => (det.open = false));
  },
};

mrp.init();
